import * as React from 'react'

import { useTheme } from '@emotion/react'

const CheckboxCheckedIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const theme = useTheme()

  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0a8 8 0 00-8 8v8a8 8 0 008 8h8a8 8 0 008-8V8a8 8 0 00-8-8H8zm9.936 9.686a1.5 1.5 0 00-2.122-2.122l-5.689 5.69-1.94-1.94a1.5 1.5 0 00-2.12 2.122l3 3a1.5 1.5 0 002.12 0l6.75-6.75z"
        fill={theme.colors.checkboxSelected}
      />
    </svg>
  )
}

export default CheckboxCheckedIcon
